interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  centered?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, centered = false }: SectionHeadingProps) {
  return (
    <div className={`mb-10 md:mb-14 ${centered ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}`}>
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium tracking-wide text-primary-800">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent-500"></span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>
      ) : null}
    </div>
  );
}